import { useFormContext as C, Controller as V } from "../../node_modules/react-hook-form/dist/index.esm.js";
import "../../UI/style.js";
import "../../node_modules/classnames/index.js";
import "../../UI/FormGrid/formGrid2.js";
import { jsx as e, jsxs as v, Fragment as d } from "../../_virtual/jsx-runtime.js";
import { UIInputContainer as f } from "../../UI/FormGrid/InputContainer.js";
import { UIInputText as j } from "../../UI/Input/UIInputText.js";
import "../../UI/Input/UIInputDate.js";
import "../../UI/Input/UIInputCheckbox.js";
import "../../UI/Input/UIInputFile.js";
import "../../UI/Input/UIInputTextArea.js";
import "../../UI/Blocks/Button/Button.js";
import "../../UI/Blocks/Emphasis/emphasis2.js";
import "../../UI/Blocks/Card/card2.js";
import "react";
import "../../UI/Blocks/Toaster/toast2.js";
import "../../UI/Blocks/Toaster/toaster2.js";
import { AutoCompleteDialog as B } from "../Utils/AutoCompleteDialog.js";
function L({
  name: n,
  onChange: r,
  label: p,
  className: a,
  required: u,
  variant: m = "medium",
  placeholder: s,
  disabled: l,
  autoComplete: i
}) {
  const {
    control: g,
    setFocus: c,
    setValue: F,
    trigger: x
  } = C();
  return /* @__PURE__ */ e(V, {
    name: n,
    control: g,
    render: ({
      field: t,
      fieldState: {
        error: o,
        isTouched: I
      }
    }) => /* @__PURE__ */ e(f, {
      name: t.name,
      size: m,
      label: p,
      required: u,
      errorMessage: o == null ? void 0 : o.message,
      children: /* @__PURE__ */ v(d, {
        children: [/* @__PURE__ */ e(j, {
          variant: m,
          ref: t.ref,
          hasError: !!o,
          disabled: l,
          placeholder: s,
          className: a,
          name: t.name,
          value: t.value,
          onChange: r ? (h) => r(h.target.value, I) : t.onChange,
          onBlur: t.onBlur
        }), i && /* @__PURE__ */ e(B, {
          sourceValue: t.value,
          inputName: t.name,
          setFieldFocus: c,
          setFieldValue: F,
          triggerFieldValidation: x,
          ...i
        })]
      })
    })
  });
}
export {
  L as InputText
};
//# sourceMappingURL=InputText.js.map
